import guest from "@/middleware/guest";

export default [
  {
      path: "",
      component: () => import(/* webpackChunkName: "DashboardLayout" */ "@/modules/layout/LandingLayout"),
      children: [
          {
              path: "/acesso/:mailing",
              name: "landing",
              meta: { middleware: [guest] },
              component: () => import(/* webpackChunkName: "home" */ "./Landing"),
          },
      ]
  },
];
